// Favorites page strings — namespace `favorites`
export default {
  en: {
    title: 'My favourites',
    savedCount: '{count} game saved | {count} games saved',
    shareList: 'Share list',
    export: 'Export',
    clearAll: 'Clear all',
    removed: 'Removed from favourites',
    cleared: 'Removed {count} favourite | Removed {count} favourites',
    updateFailed: 'Couldn’t update favourites. Try again.',
    copiedToClipboard: 'Copied to clipboard',
    copyFailed: 'Copy failed',
    loading: 'Loading…',
    empty: {
      heading: 'No favourites yet',
      body: 'Tap the heart on any game to save it here for later.',
      cta: 'Browse catalog',
    },
    noMatch: 'No favourites match these filters.',
    filters: {
      priceLabel: 'Price',
      all: 'All',
      sortLabel: 'Sort:',
    },
    sort: {
      recent: 'Recently added',
      oldest: 'Oldest first',
      name: 'Name A–Z',
      priceAsc: 'Price: low to high',
      priceDesc: 'Price: high to low',
    },
    price: {
      any: 'Any price',
      lt10: 'Under €10',
      mid: '€10 – €30',
      hi: '€30 – €60',
      gt60: '€60+',
    },
    csvHeaders: {
      name: 'Name',
      platform: 'Platform',
      price: 'Price (EUR)',
    },
    shareText: 'My GAMZOR favourites:\n{items}',
    shareItem: '• {name} — {price}',
  },

  cs: {
    title: 'Moje oblíbené',
    savedCount: '{count} hra uložena | {count} hry uloženy | {count} her uloženo',
    shareList: 'Sdílet seznam',
    export: 'Exportovat',
    clearAll: 'Vymazat vše',
    removed: 'Odebráno z oblíbených',
    cleared: 'Odebrána {count} oblíbená položka | Odebrány {count} oblíbené položky | Odebráno {count} oblíbených položek',
    updateFailed: 'Oblíbené se nepodařilo upravit. Zkuste to znovu.',
    copiedToClipboard: 'Zkopírováno do schránky',
    copyFailed: 'Kopírování selhalo',
    loading: 'Načítání…',
    empty: {
      heading: 'Zatím žádné oblíbené',
      body: 'Klikněte na srdce u libovolné hry a uložte ji sem na později.',
      cta: 'Procházet katalog',
    },
    noMatch: 'Žádné oblíbené neodpovídají těmto filtrům.',
    filters: {
      priceLabel: 'Cena',
      all: 'Vše',
      sortLabel: 'Řadit:',
    },
    sort: {
      recent: 'Nedávno přidané',
      oldest: 'Nejstarší nejdříve',
      name: 'Název A–Z',
      priceAsc: 'Cena: od nejnižší',
      priceDesc: 'Cena: od nejvyšší',
    },
    price: {
      any: 'Jakákoli cena',
      lt10: 'Do 10 €',
      mid: '10 € – 30 €',
      hi: '30 € – 60 €',
      gt60: '60 € a více',
    },
    csvHeaders: {
      name: 'Název',
      platform: 'Platforma',
      price: 'Cena (EUR)',
    },
    shareText: 'Moje oblíbené na GAMZOR:\n{items}',
    shareItem: '• {name} — {price}',
  },
};
